import React from "react";
import {
  ContentCardType,
  ContentCategoryType,
} from "../../../controller/MasterController";
import { getHotelInfoTitle } from "../../../utils/util";
import { useRecoilState } from "recoil";
import { langState, langText } from "../../../recoil/lang";

interface CardProps {
  item: ContentCardType;
  navigateSector: any;
}

const CardContent = ({ item, navigateSector }: CardProps) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  return (
    <div className="storeItem" onClick={() => navigateSector(item)}>
      <img className="titleImg" src={`${item.data.url}`} />
      <div className="itemContent">
        <p>{getHotelInfoTitle(item.data, lang)}</p>
      </div>
    </div>
  );
};
export default CardContent;
